import { useState, useEffect } from 'react';
import {
  Menu,
  MenuButton,
  MenuList,
  IconButton,
  Box,
  Button,
  Text,
  VStack,
  HStack,
  Divider,
  Badge,
  Flex,
  Checkbox,
} from '@chakra-ui/react';
import { FilterOutlined } from '@ant-design/icons';
 
const FILTER_CATEGORIES = [
  'Parent',
  'Sprint',
  'Assignee',
  'Work type',
  'Labels',
  'Status',
  'Priority',
];
 
const EmployeeFilterMenu = ({
  assignedEmployee = [],
  initialSelectedIds = [],
  onApply,
}) => {
  const [selectedIds, setSelectedIds] = useState(initialSelectedIds);
  const [activeCategory, setActiveCategory] = useState('Parent');
 
  useEffect(() => {
    setSelectedIds(initialSelectedIds);
  }, [initialSelectedIds]);
 
  const toggle = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };
 
  const handleApply = () => {
    onApply && onApply(selectedIds);
  };
 
  const handleClearAll = () => {
    setSelectedIds([]);
  };
 
  return (
    <Menu closeOnSelect={false} matchWidth={false}>
      <MenuButton
        as={IconButton}
        icon={<FilterOutlined />}
        size="sm"
        aria-label="Filter"
      />
      <MenuList
        minW="500px"
        maxH="360px"
        overflow="hidden"
        p={0}
        borderRadius="6px"
      >
        <Flex>
          {/* Left sidebar */}
          <Box
            w="170px"
            borderRight="1px solid"
            borderColor="gray.200"
            py={3}
            px={3}
          >
            <VStack align="stretch" spacing={1}>
              {FILTER_CATEGORIES.map((cat) => (
                <HStack
                  key={cat}
                  spacing={2}
                  cursor="pointer"
                  px={2}
                  py={1}
                  borderRadius="4px"
                  bg={activeCategory === cat ? 'gray.100' : 'transparent'}
                  _hover={{ bg: 'gray.50' }}
                  onClick={() => setActiveCategory(cat)}
                  justify="space-between"
                >
                  <Text fontSize="14px">{cat}</Text>
                  {cat === 'Priority' && (
                    <Badge fontSize="10px" ml="auto" colorScheme="blue">
                      1
                    </Badge>
                  )}
                </HStack>
              ))}
            </VStack>
            <Box mt={4}>
              <Button
                size="xs"
                variant="ghost"
                onClick={handleClearAll}
                w="full"
              >
                Clear all
              </Button>
            </Box>
          </Box>
 
          {/* Right panel */}
        <Box flex="1" p={4}>
  {activeCategory === 'Assignee' ? (
    <>
      {assignedEmployee.length > 0 ? (
        <>
          <VStack align="stretch" spacing={1}>
            {assignedEmployee.map((emp) => {
              const isSelected = selectedIds.includes(emp.user_id);
              const initials = emp.username
                .split(' ')
                .map((n) => n[0])
                .join('')
                .slice(0, 2)
                .toUpperCase();
              return (
                <Flex
                  key={emp.user_id}
                  align="center"
                  px={3}
                  py={2}
                  borderRadius="6px"
                  cursor="pointer"
                  onClick={() => toggle(emp.user_id)}
                  _hover={{ bg: 'gray.50' }}
                  bg={isSelected ? 'gray.100' : 'transparent'}
                  justify="start"
                  gap={3}
                >
                  <Checkbox
                    isChecked={isSelected}
                    onChange={() => toggle(emp.user_id)}
                    aria-label={`Select ${emp.username}`}
                  />
                  <Box
                    w="32px"
                    h="32px"
                    borderRadius="full"
                    bg="blue.500" // fixed blue background
                    color="white"
                    fontWeight="600"
                    fontSize="12px"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    flexShrink={0}
                  >
                    {initials}
                  </Box>
                  <Text fontSize="14px" flex="1" whiteSpace="nowrap">
                    {emp.username}
                  </Text>
                </Flex>
              );
            })}
          </VStack>
          <Divider my={3} />
          <HStack justify="space-between">
            <Button size="xs" variant="ghost" onClick={handleClearAll}>
              Clear
            </Button>
            <Button size="xs" colorScheme="blue" onClick={handleApply}>
              Apply
            </Button>
          </HStack>
        </>
      ) : (
        <Box color="gray.500">No employees found</Box>
      )}
    </>
  ) : (
    <Box
      h="100%"
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDir="column"
      color="gray.600"
    >
      <Text fontSize="14px" mb={2}>
        Select a field to start creating a filter.
      </Text>
      <Text fontSize="12px" color="gray.400">
        ({activeCategory} has no options yet)
      </Text>
    </Box>
  )}
</Box>
 
        </Flex>
      </MenuList>
    </Menu>
  );
};
 
export default EmployeeFilterMenu;